import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 获取角色权限列表
const findById = obj => new Promise((resolve, reject) => {
    const {
        roleId,
        token
    } = obj;
    request({
        url: apis.role_find + '?roleId=' + roleId + '&token=' + token,
    }).then(res => {
        resolve(res);
    })
});

const allRole = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj;
    request({
        url: apis.role_all + '?token=' + token,
    }).then(res => {
        resolve(res);
    })
});

const addRole = obj => new Promise((resolve, reject) => {
    const {
        token,
        roleForm
    } = obj;
    request({
        url: apis.role_save + '?token=' + token,
        data:roleForm
    }).then(res => {
        resolve(res);
    })
});


// 修改角色权限
const updateRole = obj => new Promise((resolve, reject) => {
    const {
        roleId,
        pageArrs,
        token
    } = obj;
    request({
        url: apis.role_change + '?roleId=' + roleId + '&pageArrs=' + pageArrs + '&token=' + token,
    }).then(res => {
        resolve(res);
    })
});



export default {
    allRole,
    addRole,
    findById,
    updateRole
}



// WEBPACK FOOTER //
// ./src/service/role_api.js